import { Tooltip } from "@material-tailwind/react";

export const TimelineChart = ({ data }: { data: any[] }) => {
  const sortedData = [...data].sort((a, b) => a.data[0] - b.data[0]);
  const maxDays = Math.max(...data.map((item) => item.data[0])) + 2;

  // Group points by their values
  const groupedPoints = sortedData.reduce((acc, item) => {
    const value = item.data[0];
    if (!acc[value]) {
      acc[value] = [];
    }
    acc[value].push(item);
    return acc;
  }, {} as Record<number, typeof sortedData>);

  return (
    <div className="w-full max-w-6xl mx-auto px-4">
      <div className="border-2 border-gray-300 p-6">
        <div className="relative w-full h-[100px]">
          <div className="absolute top-1/2 w-full h-[2px] bg-black flex items-center">
            <div className="absolute left-0 w-[2px] h-12 bg-black" />
            <div className="absolute right-0 w-[2px] h-12 bg-black" />
          </div>

          {Object.entries(groupedPoints).map(([value, items]: any) => {
            const position = (Number(value) / maxDays) * 100;

            // Create tooltip content with all items that share the same value
            const tooltipContent = (
              <div className="text-sm">
                {items.map((item: any) => (
                  <div key={item.name}>
                    {item.name} - {item.data[0]} days
                  </div>
                ))}
              </div>
            );

            return (
              <Tooltip
                content={tooltipContent}
                placement="top"
                key={value}
                className="bg-white text-black border border-gray-300 p-2"
              >
                <div
                  className="absolute transform -translate-x-1/2"
                  style={{
                    left: `${position}%`,
                    top: "50%",
                  }}
                >
                  <div className="relative -translate-y-1/2">
                    <div className="w-3 h-3 bg-black rounded-full" />
                    <div className="absolute left-1/2 transform -translate-x-1/2 -top-6">
                      <span className="text-sm font-bold">{value}</span>
                    </div>
                  </div>
                </div>
              </Tooltip>
            );
          })}
        </div>
      </div>
    </div>
  );
};
